import icd_10_codes from './icd_10_codes.json';

export const ICD_10_CODES = icd_10_codes;
